import Vue from 'vue'
import Vuex from 'vuex'

// Module  base
import form from './modules/base/form'

// Module auth
import auth from './modules/auth'

// Module admin
import users from './modules/admin/users'
import schools from './modules/admin/schools'
import turns from './modules/admin/turns'
import carnets from './modules/admin/carnets'
import roles from './modules/admin/roles'

import students from './modules/academic/student'
import courses from './modules/academic/courses'
import attendant from './modules/academic/attendant'
import academicBlockProducts from './modules/academic/block_products'

// Module cafeteria
import cafeteriaDeliveries from './modules/cafeteria/deliveries'
import cafeteriaEnlistment from './modules/cafeteria/enlistment'
import cafeteriaReports from './modules/cafeteria/reports'
import cafeteriaRequests from './modules/cafeteria/requests'

import external from './modules/external'

// Module restaurant
import restaurantDeliveries from './modules/restaurant/deliveries'
import restaurantEnlistment from './modules/restaurant/enlistment'
import restaurantReports from './modules/restaurant/reports'
import restaurantRequests from './modules/restaurant/requests'
import restaurantCategories from './modules/restaurant/categories'
import restauranProducts from './modules/restaurant/products'
import restaurantProductsCategories from './modules/restaurant/products/categories'
import restauranProductsSubCategories from './modules/restaurant/products/subcategories'
// Module inventory
// Products
import inventoryProducts from './modules/inventory/products'
import inventoryProductsCategories from './modules/inventory/products/categories'
import inventoryProductsSubCategories from './modules/inventory/products/subcategories'
// providers
import inventoryProviders from './modules/inventory/providers'
// reports
import inventoryReports from './modules/inventory/reports'
// Module retaineds
import retaineds from './modules/retaineds'

import papeleriaProductsCategories from './modules/papeleria/products/categories'
import papeleriaProductsSubCategories from './modules/papeleria/products/subcategories'
import papeleriaProducts from './modules/papeleria/products'

import papeleriaDeliveries from './modules/papeleria/deliveries'
import papeleriaEnlistment from './modules/papeleria/enlistment'
import papeleriaReports from './modules/papeleria/reports'
import papeleriaaRequests from './modules/papeleria/requests'

// Module schoolroutes
import RoutesDriversSchool from './modules/schoolroutes/drivers'
import schoolroutesMessenger from './modules/schoolroutes/messenger'
import schoolroutesMonitors from './modules/schoolroutes/monitors'
import schoolroutesNews from './modules/schoolroutes/news'
import schoolroutesReports from './modules/schoolroutes/reports'
import schoolroutesRoutes from './modules/schoolroutes/routes'
import schoolroutesVehicles from './modules/schoolroutes/vehicles'

// control de accesos
import controlaccesopermiss from './modules/controlacceso/permiss'
import controlaccesoreports from './modules/controlacceso/reports'
import controlaccesoturns from './modules/controlacceso/turns'
import controlaccesoqracces from './modules/controlacceso/qracces'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    form,
    auth,
    users,
    roles,
    schools,
    turns,
    carnets,
    students,
    courses,
    attendant,
    cafeteriaDeliveries,
    cafeteriaEnlistment,
    cafeteriaReports,
    cafeteriaRequests,
    restaurantDeliveries,
    restaurantEnlistment,
    restaurantReports,
    restaurantRequests,
    inventoryProducts,
    inventoryProductsCategories,
    inventoryProductsSubCategories,
    inventoryProviders,
    inventoryReports,
    retaineds,
    RoutesDriversSchool,
    schoolroutesMessenger,
    schoolroutesMonitors,
    schoolroutesNews,
    schoolroutesReports,
    schoolroutesRoutes,
    schoolroutesVehicles,
    external,
    controlaccesopermiss,
    controlaccesoreports,
    controlaccesoturns,
    controlaccesoqracces,
    restaurantCategories,
    restauranProducts,
    restaurantProductsCategories,
    restauranProductsSubCategories,
    papeleriaProductsCategories,
    papeleriaProductsSubCategories,
    papeleriaProducts,
    papeleriaDeliveries,
    papeleriaEnlistment,
    papeleriaReports,
    papeleriaaRequests,
    academicBlockProducts
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js